enum ModalLocation {
  Homepage = "Homepage",
  MyLinkedCards = "MyLinkedCards",
  DealImportantInfo = "DealImportantInfo"
}

export default ModalLocation
